import { http } from "@/app/http/client";
import { Distance } from "../model/distance";

type SearchResult = {
    distance: Distance;
};

export const getDistanceByZip = async (zip: string, installation: boolean | undefined): Promise<SearchResult> => {
    const response = await http.get<SearchResult>(
        `/get-distance?zip_code=${zip}&installation=${installation ? 1 : 0}`
    );

    return response.data;
};
